import React, { useEffect, useRef } from "react";
import { gsap, prefersReducedMotion } from "../../utils/gsap";

// Counts from 0 to `to` once the element scrolls into view.
export default function CountUp({ to, duration = 1.4 }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    if (prefersReducedMotion()) {
      el.textContent = to;
      return undefined;
    }
    const state = { v: 0 };
    el.textContent = "0";
    const ctx = gsap.context(() => {
      gsap.to(state, {
        v: to,
        duration,
        ease: "power2.out",
        onUpdate: () => (el.textContent = Math.round(state.v)),
        scrollTrigger: { trigger: el, start: "top 92%", once: true },
      });
    });
    return () => ctx.revert();
  }, [to, duration]);

  return <span ref={ref}>{to}</span>;
}
